import React, { useState } from "react";
import { ArrowRight, Search, Star } from "lucide-react";
import ImHereTo from "./ImHereTo";
import WeHavePartnered from "./WeHavePartnered";
import WeHelpClients from "./WeHelpClients";
import SeamlessPayments from "./SeamlessPayments";
import RightChoice from "./RightChoice";
import OnlinePayment from "./OnlinePayment";
import TalkWithUs from "./TalkWithUs";
import WhatOurClientsSay from "./WhatOurClientsSay";
import { FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { BiSolidMessageDots } from "react-icons/bi";
import ChatBot from "./ChatBot";
const Home = () => {
  const [isopen, setisopen] = useState(false);
  const [isopenChatBot, setisopenChatBot] = useState(false);
  // const handleOpen = (platform) => {
  //   if (platform === "Twitter") {
  //   } else if (platform === "WhatsApp") {
  //     window.open('https://wa.me/+919001249311', '_blank');
  //   }
  // };
  const handleOpen = (platform) => {
    const phoneNumber = 9001249311;
    const fullPhoneNumber = `+91${phoneNumber}`;
    const telusername = "bhart_pay_crypto";
    if (platform === "Telegram") {
      // window.open(`https://t.me/${fullPhoneNumber}`, "_blank");
      window.open(`https://t.me/${telusername}`, "_blank");
    } else if (platform === "WhatsApp") {
      window.open(`https://wa.me/${fullPhoneNumber}`, "_blank");
    }
  };

  return (
    <div className="relative">
      {/* ChatBot Screen */}
      {/* {isopenChatBot && (
        <div className="fixed z-40 right-24 bottom-14 flex  items-center justify-center ">
          <ChatBot color={color} />
        </div>
      )} */}
      {/* Chat buttons */}
      <div className="fixed z-40 md:right-10 md:bottom-10 right-6 bottom-4 flex flex-col items-center justify-center gap-3">
        <div
          className={`flex flex-col gap-2 transition-all duration-300 ease-in-out transform ${
            isopen
              ? "scale-100 opacity-100 translate-y-0"
              : "scale-0 opacity-0 translate-y-8"
          }`}
        >
          <button
            className="bg-gradient-to-r from-[#468EEB] via-[#3152DB] to-[#6540B2] px-2 py-2 rounded-full flex items-center justify-center"
            onClick={() => handleOpen("Telegram")}
          >
            <FaTelegramPlane className="text-[1.3rem] text-white" />
          </button>
          <button
            className="bg-gradient-to-r   px-2 py-2  from-[#24CC63] via-[#24CC63] to-[#24CC63] rounded-full flex items-center justify-center"
            onClick={() => handleOpen("WhatsApp")}
          >
            <FaWhatsapp className="text-[1.3rem] text-white" />
          </button>
        </div>
        <button
          onClick={() => {
            setisopen(!isopen);
            setisopenChatBot(false);
          }}
          className="relative"
        >
          <p className="bg-gradient-to-r  from-[#fb6a2b] via-[#fa5a25] to-[#e83f3b]  px-2 py-2 rounded-full flex items-center justify-center z-20">
            <BiSolidMessageDots className="text-[1.6rem] text-white" />
          </p>
        </button>
      </div>

      {/* ---- */}
      <div className="bgHeroImage" id="Features">
        {/* <Header/> */}
        <div className="container px-4 md:px-6 flex flex-col lg:flex-row items-center gap-6 pb-8 pt-10 md:pb-12 md:pt-16 lg:pt-20 m-auto">
          <div className="lg:w-1/2 relative">
            <div className="space-y-8">
              <h1 className="text-5xl md:text-6xl lg:text-8xl font-bold tracking-tight text-[#6540b2]">
                <span className="inline-flex items-center gap-2">
                  Find{" "}
                  <Search className="w-12 h-12 text-[#fb6a2b] animate-ping ml-3" />
                </span>
                <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#fb6a2b] to-[#e83f3b]">
                  visibility
                </span>
                <br />
                across the world payment.
              </h1>
              <p className="text-xl md:text-lg text-gray-600 max-w-xl">
                For businesses, accepting crypto payments means tapping into a
                growing, tech-savvy customer base while reducing transaction
                fees. For consumers, it means embracing financial independence
                and seamless digital asset management.
              </p>

              <div className="flex items-center space-x-4">
                <div className="flex -space-x-3">
                  {[...Array(5)].map((_, i) => (
                    <div
                      key={i}
                      className="w-12 h-12 rounded-full border-2 border-white bg-gray-200 flex items-center justify-center overflow-hidden"
                    >
                      <img
                        src={require("../../assets/image/user-avatar-icon.png")}
                        alt={`User ${i + 1}`}
                        width={48}
                        height={48}
                        className="object-cover"
                      />
                    </div>
                  ))}
                </div>
                <div>
                  <p className="font-semibold text-[#6540b2]">12,000+ users</p>
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className="w-4 h-4 text-yellow-400 fill-current"
                      />
                    ))}
                    <span className="ml-2 text-gray-600">4.9/5 rating</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:w-1/2 relative m-auto">
            <div className="relative w-auto overflow-hidden">
              <img
                src={require("../../assets/image/RKR_FULL-svg.png")}
                alt="Fantop Dashboard"
                fill
                className="object-cover rounded-xl"
                priority
              />
            </div>
            <div className="absolute bottom-24 -left-28 shadow-lg bg-[#fff] bg-opacity-85 rounded-2xl z-[2]">
              <div className="p-5">
                <div className="p-2 rounded-full flex items-center justify-center m-auto bg-[#eae8fc] w-[60px] h-[60px]">
                  <ArrowRight className="h-8 w-8 text-primary -rotate-45 text-[#fb6a2b]" />
                </div>
                <div className="mt-4">
                  <div className="text-sm font-medium text-center text-[#6540b2]">
                    Total transfer
                  </div>
                  <div className="text-2xl font-bold text-center text-[#6540b2]">
                    +$12,750.20
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <div className="absolute -bottom-10 lg:-left-20 md:-left-20 sm:left-0 left-0 shadow-lg bg-[#fff] rounded-xl bg-opacity-85 lg:w-96 md:w-96 sm::w-full w-full">
                <div className="p-6">
                  <div className="space-y-4">
                    <div className="space-y-2">
                      <div className="flex justify-between text-sm mb-4">
                        <span className="text-[#43464e] text-[14px] font-[500]">
                          From
                        </span>
                        <span className="font-medium text-[17px] text-[#6540b2]">
                          WePe 3445 6413 5445
                        </span>
                      </div>
                      <div className="flex justify-between text-sm mb-4">
                        <span className="text-[#43464e] text-[14px] font-[500]">
                          To
                        </span>
                        <span className="font-medium text-[17px] text-[#6540b2]">
                          3445 6423 5445
                        </span>
                      </div>
                      <div className="flex justify-between text-sm mb-4">
                        <span className="text-[#43464e] text-[14px] font-[500]">
                          Transfer
                        </span>
                        <span className="font-medium text-[17px] text-[#6540b2]">
                          $3,205.20
                        </span>
                      </div>
                      <div className="flex justify-between text-sm mb-4">
                        <span className="text-[#43464e] text-[14px] font-[500]">
                          Admin fee
                        </span>
                        <span className="font-medium text-[17px] text-[#6540b2]">
                          Free
                        </span>
                      </div>
                      <div className="border border-[#e7e7e7] my-3" />
                      <div className="flex justify-between text-sm font-medium">
                        <span className="text-[#43464e] text-[14px] font-[500]">
                          Total Transfer
                        </span>
                        <span className="font-medium text-[17px] text-[#6540b2]">
                          $1,000.00
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 
      <ImHereTo />
      <WeHavePartnered />
      <WeHelpClients />
      <SeamlessPayments />
      <RightChoice />
      <OnlinePayment />
      <WhatOurClientsSay />
      <TalkWithUs /> */}
      <section id="How it Work">
        <ImHereTo />
      </section>

      <section id="How it Work">
        <WeHavePartnered />
      </section>

      <section id="About">
        <WeHelpClients />
      </section>

      <section id="Developers">
        <SeamlessPayments />
      </section>

      <section id="Contact">
        <TalkWithUs />
      </section>
    </div>
  );
};

export default Home;
